import { useState, useEffect, useMemo } from 'react';
import { supabase } from '@/integrations/supabase/client';

interface ScheduledCall {
  id: string;
  deal_id: string;
  title: string | null;
  scheduled_for: string;
  channel: 'voice' | 'video';
  handled_by_app_user_id: string | null;
}

export function useScheduledCallsByDeal() {
  const [calls, setCalls] = useState<ScheduledCall[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadScheduledCalls = async () => {
      const now = new Date().toISOString();
      
      const { data, error } = await supabase
        .from('calls')
        .select('id, deal_id, title, scheduled_for, channel, handled_by_app_user_id')
        .not('deal_id', 'is', null)
        .eq('status', 'scheduled')
        .gt('scheduled_for', now)
        .order('scheduled_for', { ascending: true })
        .limit(500);

      if (error) {
        console.error('Error loading scheduled calls:', error);
        setCalls([]);
      } else {
        setCalls(data || []);
      }
      setLoading(false);
    };

    loadScheduledCalls();
  }, []);

  // Map: deal_id -> next scheduled call (the earliest one)
  const scheduledCallsByDeal = useMemo(() => {
    const map = new Map<string, ScheduledCall>();
    
    for (const call of calls) {
      if (call.deal_id && !map.has(call.deal_id)) {
        map.set(call.deal_id, call);
      }
    }
    
    return map;
  }, [calls]);

  return { scheduledCallsByDeal, loading };
}
